import React, { type FC, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from 'react-query';

import WiseModal from 'components/wise/WiseModal';
import WiseTabs from 'components/wise/WiseTabs';
import CartImportCsvTab from 'components/wise/WiseCartImportModal/components/CartImportCsvTab';
import CartImportOrdersTab from 'components/wise/WiseCartImportModal/components/CartImportOrdersTab';

export type WiseCartImportModalProps = {
  open: boolean;
  cartId: number;
  onClose: () => void;
  onSuccess: () => void;
};

const WiseCartImportModal: FC<WiseCartImportModalProps> = ({
  open,
  cartId,
  onClose,
  onSuccess,
}) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const handleSuccess = useCallback(() => {
    queryClient.invalidateQueries(['cart-positions', cartId]);
    queryClient.invalidateQueries(['cart', cartId]);
    queryClient.invalidateQueries(['carts-all']);
    onSuccess();
  }, [cartId, onSuccess, queryClient]);

  const tabs = useMemo(
    () => [
      {
        label: t('Import z pliku CSV'),
        children: <CartImportCsvTab cartId={cartId} onSuccess={handleSuccess} />,
      },
      {
        label: t('Import z zamowienia'),
        children: <CartImportOrdersTab cartId={cartId} onSuccess={handleSuccess} />,
      },
    ],
    [cartId, handleSuccess, t]
  );

  return (
    <WiseModal
      open={open}
      onClose={onClose}
      title={t('Importuj do koszyka')}
      maxWidth={860}>
      <WiseTabs tabs={tabs} defaultTabIndex={0} />
    </WiseModal>
  );
};

export default WiseCartImportModal;
